import AbortError from '../errors/AbortError';

class Repository {
  constructor(basePath, services) {
    this._basePath = basePath;
    this._services = services;
    this._request = this._request.bind(this);
    this._requestAborted = this._requestAborted.bind(this);
    this.abortedRequestControllers = new Map();

    this.request = this._initRequest();
    this.requestAborted = this._initRequest(true);
  }

  get services() {
    return this._services;
  }

  set services(services) {
    this._services = services;
  }

  setAbortedRequestController(key, controller) {
    this.abortedRequestControllers.set(key, controller);
  }

  deleteAbortedRequestController(key) {
    this.abortedRequestControllers.delete(key);
  }

  _initRequest(isAborted = false) {
    const request = isAborted ? this._requestAborted : this._request;
    function getRequestWithMethod(method) {
      function createDataWithMethod(data) {
        return { ...data, method };
      }
      if (isAborted) {
        return function (key, service, data) {
          const requestData = createDataWithMethod(data);
          return request(key, service, requestData);
        };
      } else {
        return function (service, data) {
          const requestData = createDataWithMethod(data);
          return request(service, requestData);
        };
      }
    }

    request.post = getRequestWithMethod('post');
    request.get = getRequestWithMethod('get');
    request.put = getRequestWithMethod('put');
    request.delete = getRequestWithMethod('delete');
    return request;
  }

  async _request(service, data) {
    const trimmedUrl = data.url ? data.url.replace(/\/{2,}/, '/') : '';
    data.url = `${this._basePath ? this._basePath : ''}${trimmedUrl ? `/${trimmedUrl}` : ''}`;
    return await service.request(data);
  }

  async _requestAborted(key, service, data) {
    const controller = new AbortController();
    if (this.abortedRequestControllers.has(key)) {
      this.abortedRequestControllers.get(key).abort();
    }
    this.setAbortedRequestController(key, controller);
    try {
      const response = await this._request(service, { ...data, signal: controller.signal });
      this.deleteAbortedRequestController(key);
      return response;
    } catch (e) {
      if (!(e instanceof AbortError)) {
        this.deleteAbortedRequestController(key);
      }
      throw e;
    }
  }
}

export default Repository;
